import {Component, OnInit} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {CustomMessageService, LocalStorageService, UtilService, ResponseHttpSuccess, ResponseHttpError} from 'library';
import {CommissionsService} from 'projects/store/src/app/services/api/v1/commissions.service';
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-commission-stores',
  templateUrl: './commission-stores.component.html',
  styleUrls: ['./commission-stores.component.scss'],
})
export class CommissionStoresComponent implements OnInit{
  label = 'Mis tiendas';
  date = new Date();
  month: Date;
  year: Date;
  userId: any;
  listStores: any[] = [];
  listSaleOneStore: any[] = [];
  userData: UserData;
  commissionStore: any;

  constructor(private customMessageService: CustomMessageService,
              private commissionsService: CommissionsService,
              private utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.year = new Date();
    this.month = new Date();
    this.userData = this.localStorageService.get(LocalStorageKey.data);
    this.userId = this.userData.user.id;
  }
  ngOnInit() {
    this.load();
  }
  load() {
    this.utilService.enablePageLoading();
    this.commissionsService.getListStoreByDealer(this.userData.distributor.id).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listStores = resp.body.data.list;
          this.loadSaleOneStore(this.listStores[0].id);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }

  onChangeTab($event: any) {
    let seletecedStore = this.listStores[$event.index];
    this.loadSaleOneStore(seletecedStore.id);
  }

  loadSaleOneStore(storeId: string){
    this.listSaleOneStore = [];
    this.utilService.enablePageLoading();
    forkJoin({
      sales: this.commissionsService.getSalesOfOneStore(storeId),
      commissions: this.commissionsService.getCommissionsOfOneStore(storeId, this.userId)
    }).subscribe(resp =>{
      if (resp.sales.status === HttpStatusCode.Ok){
        this.listSaleOneStore = [resp.sales.body.data];
      }else{
        this.customMessageService.responseNoticeHandler(resp.sales);
      }
      if (resp.commissions.status === HttpStatusCode.Ok){
        this.commissionStore = resp.commissions.body.data.accumulated_commissions;
      }else{
        this.customMessageService.responseNoticeHandler(resp.commissions);
      }
      this.utilService.disablePageLoading();
    }, error => {
      this.customMessageService.responseNoticeHandler(error);
    });
  }
}
